module.exports = __webpack_public_path__ + "static/media/16.c79169ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/16.jpg
// module id = 529
// module chunks = 0